import { z } from 'zod';
export const nonEmptyString = z.string().trim().min(1);
export const optionalString = z.string().trim().nullable().optional();
export const emailSchema = z.string().email().nullable().optional();
export const phoneSchema = z.string().max(50).nullable().optional();
export const urlSchema = z.string().url().nullable().optional();
export const uuidSchema = z.string().uuid();
export const metadataSchema = z.record(z.unknown()).optional().default({});
export const isoDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);
export const isoDateOptional = isoDateSchema.nullable().optional();
export const idParamSchema = z.object({
    id: uuidSchema,
});
export const listQuerySchema = z.object({
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(100).optional().default(25),
    sort: z.string().optional(),
    search: z.string().optional(),
    filter: z.record(z.string()).optional(),
});
export const offsetListQuerySchema = z.object({
    page: z.coerce.number().int().min(1).optional().default(1),
    limit: z.coerce.number().int().min(1).max(100).optional().default(20),
    sort_by: z.string().optional(),
    sort_order: z.enum(['asc', 'desc']).optional().default('asc'),
});
//# sourceMappingURL=common.js.map